import RootRoutes from "./RootRoutes";
export default RootRoutes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/RootRoutes/index.tsx